import { Box, Button, ButtonGroup } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { cloneElement, useCallback, useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";


/*
const useStyles = makeStyles()((theme) => ({
  buttonGroup: {
    /!*
    display: "block",
    *!/
    margin: theme.spacing(1),

    right: "15vh",
    position: "fixed",
    bottom: "0vh"
  },
  root: {},
  /!*div: {
    overflow: "auto",
    display: "block",
  },*!/
  child: {
    scrollSnapAlign: "start",
    scrollSnapStop: "always"
  }
  /!*boxShadow: {
    boxShadow: `10px 5px 5px ${theme.palette.primary.main}`,
  },*!/
}));
*/

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    /*alignItems: "center",
    alignContent: "center",*/
    justifyItems: "center",
    justifyContent: "center",
    height: "100vh",
    margin: 0

  },
  BoxSlide: {

    //alignItems: "center",
    //alignContent: "center",
    //justifyItems: "center",
    justifyContent: "space-evenly"
  },
  child: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    justifyContent: "center",

    scrollSnapAlign: "start",
    scrollSnapStop: "always",
    scrollSnapType: "x mandatory"

  },
  buttonGroup: {
    margin: theme.spacing(1),
    right: "15vh",
    position: "fixed",
    bottom: "0vh"
  }
}));

const Scroller = ({ cookieSelected, loginStatus, activeField, setActiveField, children }) => {

  const { classes } = useStyles();

  const { trigger, setFocus, formState: { errors } } = useFormContext();
  const activeFieldRef = useRef(null); // field by element
  const containerRef = useRef(null);
  const slideCount = useRef(0);
  const [direction, setDirection] = useState(true);
  const [validationList, setValidationList] = useState([]);
  const activeValidRef = useRef(false);
  const [skipSlides, setSkipSlides] = useState(new Array(children.length));

  children = children.filter(Boolean);

  useEffect(() => {
    if (loginStatus) {
      slideCount.current = children.length - 1; // -1 b/c currently just one "guestOnly" slide

    } else {
      slideCount.current = children.length;
    }

  }, [loginStatus]);

  useEffect(() => {
    const focusActiveFieldRef = () => {
      if (activeFieldRef.current) {
        activeFieldRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest"
        });

        activeFieldRef.current.focus();
      }
    };
    focusActiveFieldRef();

  }, [activeField]);




  const movingNext = useCallback(async () => {
      if (validationList && validationList.length > 0) {
        const result = await trigger(validationList);
        if (result === true) {
          // check if next field is meant to be skipped
          if (skipSlides[activeField] === 1) {
            setActiveField(Math.min(slideCount.current - 1, activeField + 2));
          }
          else {
            setActiveField(Math.min(slideCount.current - 1, activeField + 1));
          }


        } else {
          if (errors) {
            // Because of the way errors are nested Platform errors need to be handled differently
            const errorList = (errors.platforms && errors.hasPlatform) ? ["platforms", "hasPlatform"] : Object.keys(errors);
            if (errorList[0]) {
              if (errorList[0] === "platforms") { // platform errors
                const firstPlatformError = Object.keys(errors?.platforms)[0];
                if (firstPlatformError === "Other") {
                  setFocus("platforms.Other.request");
                } else {
                  if (errors.platforms[firstPlatformError].cookie) {
                    setFocus(`platforms[${firstPlatformError}].cookie`);
                  }
                }
              } else { // All other errors
                setFocus(errorList[0]);
              }
            }
          } else {
            console.log("Something went wrong...");
          }
        }
      } else {
        // check if next field is meant to be skipped
        if (skipSlides[activeField] === 1) {
          setActiveField(Math.min(slideCount.current - 1, activeField + 2));
        }
        else {
          setActiveField(Math.min(slideCount.current - 1, activeField + 1));
        }
      }
    },
    [validationList, activeField, slideCount]);


  const movingPrevious = useCallback(() => {
    if (skipSlides[activeField-2] === 1) {
      setActiveField(Math.max(0, activeField - 2));
    }
    else  {
      setActiveField(Math.max(0, activeField - 1));
    }
  }, [activeField]);

  return (
    <Box direction="row" className={classes.root} ref={containerRef}>
      <ButtonGroup
        className={classes.buttonGroup}
        orientation="horizontal"
        color="primary"
        variant="outlined" aria-label="outlined button group"
      >
        <Button variant="outlined" tabIndex={-1} disabled={activeField === 0}
                onClick={movingPrevious}>
          Previous
        </Button>
        <Button variant="outlined" tabIndex={-1}
                disabled={slideCount.current - 1 === activeField} onClick={movingNext}>
          Next
        </Button>
      </ButtonGroup>


      {children.map((child, i) => {
        const active = i === activeField;

        const newChild = cloneElement(child, {
          slideId: i,
          next: movingNext,
          previous: movingPrevious,
          setActive: setActiveField,
          setValidationList: setValidationList,
          activeField: activeField,
          loginStatus: loginStatus
        });

        if (loginStatus && newChild.props.guestOnly) {
          skipSlides[newChild.props.slideId-1] = 1;
          //console.log("LOGGED IN"); // skip creating contact/login info slide(s)
        } else if (!cookieSelected && newChild.props.showCookie) {
          skipSlides[newChild.props.slideId-1] = 1;
          //console.log("LOGGED IN"); // skip creating contact/login info slide(s)
        } else {
          skipSlides[newChild.props.slideId -1] = 0;
          return (
            <Box
              className={`${classes.child} field ${active ? "active" : ""}`}
              ref={active ? activeFieldRef : null}
              id={`field-${i}`}
              key={`field-${i}`}
            >
              {newChild}
            </Box>
          );
        }
      })}
    </Box>
  );
};

export { Scroller };
